export default "__VITE_ASSET__42b7779e__"